<template>
	<v-text-field
		v-model="setEmail"
    class="mt-4"
		:rules="[rules.required, rules.emailFormat]"
		label="メールアドレス(必須)"
		outlined
		dense
		required
	></v-text-field>
</template>

<script>
import rules from "../../../helper/rules"

export default {
	props: {
		email: {
			type: String,
			default: "",
		},
	},
	data() {
		return {
			rules: rules,
		}
	},
	computed: {
		setEmail: {
			get() {
				return this.email
			},
			set(newValue) {
				return this.$emit("update:email", newValue)
			},
		},
	},
}
</script>
